exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".map-active-wrapper[data-v-0bd3010a] {\n  width: 100%;\n  height: 80vw;\n}\n", ""]);
